/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationPractitioner } from './HomeHealthCertificationPractitioner';
import {
    HomeHealthCertificationPractitionerFromJSON,
    HomeHealthCertificationPractitionerFromJSONTyped,
    HomeHealthCertificationPractitionerToJSON,
    HomeHealthCertificationPractitionerToJSONTyped,
} from './HomeHealthCertificationPractitioner';
import type { HomeHealthCertificationStatus } from './HomeHealthCertificationStatus';
import {
    HomeHealthCertificationStatusFromJSON,
    HomeHealthCertificationStatusFromJSONTyped,
    HomeHealthCertificationStatusToJSON,
    HomeHealthCertificationStatusToJSONTyped,
} from './HomeHealthCertificationStatus';
import type { HomeHealthCertificationSignature } from './HomeHealthCertificationSignature';
import {
    HomeHealthCertificationSignatureFromJSON,
    HomeHealthCertificationSignatureFromJSONTyped,
    HomeHealthCertificationSignatureToJSON,
    HomeHealthCertificationSignatureToJSONTyped,
} from './HomeHealthCertificationSignature';
import type { HomeHealthCertificationReviewReason } from './HomeHealthCertificationReviewReason';
import {
    HomeHealthCertificationReviewReasonFromJSON,
    HomeHealthCertificationReviewReasonFromJSONTyped,
    HomeHealthCertificationReviewReasonToJSON,
    HomeHealthCertificationReviewReasonToJSONTyped,
} from './HomeHealthCertificationReviewReason';

/**
 * 
 * @export
 * @interface HomeHealthCertificationCertification
 */
export interface HomeHealthCertificationCertification {
    /**
     * 
     * @type {HomeHealthCertificationStatus}
     * @memberof HomeHealthCertificationCertification
     */
    artifact_status: HomeHealthCertificationStatus;
    /**
     * 
     * @type {Array<HomeHealthCertificationReviewReason>}
     * @memberof HomeHealthCertificationCertification
     */
    review_reasons: Array<HomeHealthCertificationReviewReason>;
    /**
     * 
     * @type {HomeHealthCertificationSignature}
     * @memberof HomeHealthCertificationCertification
     */
    certification_signature: HomeHealthCertificationSignature;
    /**
     * 
     * @type {HomeHealthCertificationPractitioner}
     * @memberof HomeHealthCertificationCertification
     */
    certifying_practitioner: HomeHealthCertificationPractitioner;
}



/**
 * Check if a given object implements the HomeHealthCertificationCertification interface.
 */
export function instanceOfHomeHealthCertificationCertification(value: object): value is HomeHealthCertificationCertification {
    if (!('artifact_status' in value) || value['artifact_status'] === undefined) return false;
    if (!('review_reasons' in value) || value['review_reasons'] === undefined) return false;
    if (!('certification_signature' in value) || value['certification_signature'] === undefined) return false;
    if (!('certifying_practitioner' in value) || value['certifying_practitioner'] === undefined) return false;
    return true;
}

export function HomeHealthCertificationCertificationFromJSON(json: any): HomeHealthCertificationCertification {
    return HomeHealthCertificationCertificationFromJSONTyped(json, false);
}

export function HomeHealthCertificationCertificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeHealthCertificationCertification {
    if (json == null) {
        return json;
    }
    return {
        
        'artifact_status': HomeHealthCertificationStatusFromJSON(json['artifact_status']),
        'review_reasons': ((json['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonFromJSON)),
        'certification_signature': HomeHealthCertificationSignatureFromJSON(json['certification_signature']),
        'certifying_practitioner': HomeHealthCertificationPractitionerFromJSON(json['certifying_practitioner']),
    };
}

export function HomeHealthCertificationCertificationToJSON(json: any): HomeHealthCertificationCertification {
    return HomeHealthCertificationCertificationToJSONTyped(json, false);
}

export function HomeHealthCertificationCertificationToJSONTyped(value?: HomeHealthCertificationCertification | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'artifact_status': HomeHealthCertificationStatusToJSON(value['artifact_status']),
        'review_reasons': ((value['review_reasons'] as Array<any>).map(HomeHealthCertificationReviewReasonToJSON)),
        'certification_signature': HomeHealthCertificationSignatureToJSON(value['certification_signature']),
        'certifying_practitioner': HomeHealthCertificationPractitionerToJSON(value['certifying_practitioner']),
    };
}

